import { Loader } from "shared/components/Loader";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { AutoLoadMoreOnScroll } from "shared/app/Notes/components/AutoLoadMoreOnScroll";
import { BrandingTarget } from "types/landlord/address";
import { getErrorMessage } from "utils/error";
import { PropertyChecklistRow } from "./PropertyChecklistRow";

export const BrandingTargetsList = ({
  visibleTargets,
  hasSearch,
  selectedIds,
  onToggle,
  isLoading,
  isError,
  error,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore
}: {
  visibleTargets: BrandingTarget[];
  hasSearch: boolean;
  selectedIds: Map<number, BrandingTarget>;
  onToggle: (target: BrandingTarget) => void;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();

  if (isLoading)
    return (
      <div className="flex items-center justify-center py-10">
        <Loader />
      </div>
    );

  if (isError)
    return (
      <p className="py-6 text-sm font-medium text-danger-500">
        Failed to load {dictionary.properties}: {getErrorMessage(error)}
      </p>
    );

  if (visibleTargets.length === 0)
    return (
      <p className="py-6 text-sm text-content-400">
        {hasSearch
          ? `No ${dictionary.properties} match your search.`
          : `There are no other ${dictionary.properties} to apply branding to.`}
      </p>
    );

  return (
    <div className="min-h-0 flex-1 space-y-1 overflow-y-auto">
      {visibleTargets.map((target) => (
        <PropertyChecklistRow
          checked={selectedIds.has(target.id)}
          key={target.id}
          onToggle={() => onToggle(target)}
          target={target}
        />
      ))}

      {isFetchingNextPage ? (
        <div className="flex items-center justify-center py-2">
          <Loader size={20} />
        </div>
      ) : null}

      <AutoLoadMoreOnScroll
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        onLoadMore={onLoadMore}
      />
    </div>
  );
};
